import React from 'react';
import MissionDetail from './MissionDetail';
import missionsData from '../data/missions.json';

function MissionEducation() {
  return <MissionDetail mission={missionsData.education} />;
}

export default MissionEducation;
